import React from "react";
import PropTypes from "prop-types";
import tw, { styled } from "twin.macro";
import Project from "./project.js";

const Content = styled.div`
  ${tw`font-light`};
`;

const Header = styled.div`
  ${tw`text-2xl font-black text-purple-dark`}
`;

const List = styled.div`
  ${tw`lg:grid lg:grid-rows-2 grid-flow-col gap-x-8 font-light text-purple-dark`}
`;

const Labels = {
  opensource_projects: "Opensource Projects",
};

const capitalize = function (string) {
  string = string.replace(/_/g, " ");

  return string.charAt(0).toUpperCase() + string.slice(1);
};

const ProjectList = ({ title, items }) => {
  return (
    <Content>
      <Header>{Labels[title] || capitalize(title)}</Header>

      <List>
        {items.map((project, index) => (
          <Project key={index} {...project} />
        ))}
      </List>
    </Content>
  );
};

ProjectList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
};

export default ProjectList;
